var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"container",attrs:{"role":"main"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('pre',[_vm._v("Manage Apps for Site ["+_vm._s(_vm.siteName)+"]")])])])])])}
var staticRenderFns = []

export { render, staticRenderFns }